// src/LocalityIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LocalityIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    height: 16,
    width: 16,
    viewBox: "0 0 123.832 123.832",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "4.95328",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { id: "SVGRepo_bgCarrier", strokeWidth: "0" }),
      /* @__PURE__ */ jsx(
        "g",
        {
          id: "SVGRepo_tracerCarrier",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#CCCCCC",
          strokeWidth: "0.9906559999999999"
        }
      ),
      /* @__PURE__ */ jsx("g", { id: "SVGRepo_iconCarrier", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "M123.325 32.313a1.228 1.228 0 0 0 -1.105 -0.169l-27.808 9.27c2.438 -5.226 4.119 -10.163 4.119 -13.857 0 -13.957 -11.354 -25.31 -25.31 -25.31 -13.955 0 -25.31 11.354 -25.31 25.31 0 2.02 0.492 4.394 1.326 6.974l-7.162 -2.387c-0.034 -0.012 -0.07 0 -0.106 -0.009 -0.094 -0.022 -0.185 -0.024 -0.282 -0.024s-0.188 0.002 -0.282 0.024c-0.034 0.009 -0.071 -0.003 -0.106 0.009L0.838 45.631A1.224 1.224 0 0 0 0 46.793v73.566c0 0.394 0.19 0.764 0.509 0.995a1.23 1.23 0 0 0 0.718 0.231c0.13 0 0.261 -0.021 0.388 -0.064l40.072 -13.357 40.072 13.357a1.234 1.234 0 0 0 0.388 0.064 1.225 1.225 0 0 0 0.382 -0.063c0.002 0 0.004 0 0.006 -0.002l40.46 -13.486a1.222 1.222 0 0 0 0.838 -1.162V33.306a1.218 1.218 0 0 0 -0.507 -0.994zM40.461 105.987 2.454 118.656V47.678l38.008 -12.669v70.979zM73.219 4.189c12.884 0 23.366 10.482 23.366 23.366 0 3.822 -1.948 9.125 -4.689 14.695a110.5 110.5 0 0 1 -1.598 3.118c-2.154 4.047 -4.604 8.114 -6.926 11.752a235 235 0 0 1 -2.453 3.764c-3.067 4.614 -5.566 8.051 -6.283 9.027l-0.837 1.138c-0.266 0.362 -0.895 0.368 -1.167 -0.006l-0.834 -1.132c-1.71 -2.329 -13.53 -18.634 -19.079 -31.633a56 56 0 0 1 -1.177 -2.978c-1.052 -2.913 -1.692 -5.573 -1.692 -7.744 0 -12.884 10.482 -23.366 23.366 -23.366zm7.702 114.467 -38.008 -12.669V35.008l7.378 2.46c5.138 13.046 17.043 29.643 19.946 33.595l0.831 1.129a2.675 2.675 0 0 0 2.152 1.092c0.849 0 1.651 -0.407 2.148 -1.086l0.835 -1.135c0.594 -0.807 2.39 -3.277 4.717 -6.704zm40.46 -12.669 -38.008 12.669V60.682c3.101 -4.741 6.649 -10.52 9.534 -16.184l28.476 -9.492v70.981z" }),
        /* @__PURE__ */ jsx("path", { d: "M73.219 40.593c6.046 0 10.964 -4.918 10.964 -10.963 -0.002 -6.046 -4.92 -10.963 -10.964 -10.963s-10.963 4.918 -10.963 10.963 4.918 10.963 10.963 10.963zm0 -19.983c4.973 0 9.019 4.047 9.021 9.021 0 4.973 -4.047 9.021 -9.021 9.021s-9.021 -4.047 -9.021 -9.021 4.047 -9.021 9.021 -9.021z" })
      ] }) }) })
    ]
  }
);
var LocalityIcon_default = LocalityIcon;

export {
  LocalityIcon_default
};
